import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2AnswerCheckpointComponent } from './fi-checklist2-answer-checkpoint/fi-checklist2-answer-checkpoint.component';
import { FiChecklist2AnswerValueComponent } from './fi-checklist2-answer-value/fi-checklist2-answer-value.component';
import { FiChecklist2AnswerCommentsComponent } from './fi-checklist2-answer-comments/fi-checklist2-answer-comments.component';
import { FiChecklist2AnswerAttachmentsComponent } from './fi-checklist2-answer-attachments/fi-checklist2-answer-attachments.component';
import { FiChecklist2AnswerCreatedByComponent } from './fi-checklist2-answer-created-by/fi-checklist2-answer-created-by.component';
import { FiWrapperTableModule } from '../../../fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        FiAppTextSharedModule,
        FiAttachmentsModule,
        FiProfileIconModule,
        MatIconModule,
    ],
    declarations: [
        FiChecklist2AnswerCheckpointComponent,
        FiChecklist2AnswerValueComponent,
        FiChecklist2AnswerCommentsComponent,
        FiChecklist2AnswerAttachmentsComponent,
        FiChecklist2AnswerCreatedByComponent,
    ],
    exports: [
        FiChecklist2AnswerCheckpointComponent,
        FiChecklist2AnswerValueComponent,
        FiChecklist2AnswerCommentsComponent,
        FiChecklist2AnswerAttachmentsComponent,
        FiChecklist2AnswerCreatedByComponent,
    ],
})
export class FiChecklist2ReportColumnDefsModule {}
